import React from "react";
import { useNavigate } from "react-router-dom";
import { CreditCard, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionShell, SCard, SRow, fmtDateFr } from "./SettingsUI";
import { useLang, translateFr as tfr } from "@/i18n";

const STATUS = {
  trialing: { label: tfr("Essai gratuit"), cls: "text-amber-400" },
  active: { label: "Actif", cls: "text-green-500" },
  past_due: { label: tfr("Paiement en retard"), cls: "text-red-400" },
  canceled: { label: tfr("Annulé"), cls: "text-red-400" },
  expired: { label: tfr("Expiré"), cls: "text-red-400" },
  inactive: { label: "Inactif", cls: "text-muted-foreground" },
};

export const SectionBilling = ({ overview }) => {
  const { tf } = useLang();
  const navigate = useNavigate();
  const sub = overview?.subscription || {};
  const meta = STATUS[sub.status] || { label: sub.status, cls: "text-muted-foreground" };
  const metaLabel = tf(meta.label);

  return (
    <SectionShell title={tf("Abonnement & facturation")} desc={tf("Votre plan, votre statut et la gestion de votre paiement.")} testid="section-billing">
      <SCard title={tf("Abonnement actuel")} testid="billing-summary-card" right={<CreditCard className="h-4 w-4 text-muted-foreground" />}>
        <SRow label={tf("Statut")} value={<span className={meta.cls}>{metaLabel}</span>} testid="billing-status" />
        {sub.status === "trialing" && <SRow label={tf("Fin de l'essai")} value={fmtDateFr(sub.trial_ends_at)} testid="billing-trial-end" />}
        {sub.current_period_end && <SRow label={tf("Prochaine échéance")} value={fmtDateFr(sub.current_period_end)} testid="billing-period-end" />}
        {sub.cancel_at_period_end && <SRow label={tf("Résiliation")} value={tf("Programmée à la fin de la période")} testid="billing-cancel" />}
        <SRow label={tf("Moyen de paiement")} value={sub.stripe_customer_id_present ? tf("Enregistré via Stripe") : tf("Aucun")} testid="billing-payment-method" />
        <div className="flex flex-wrap gap-2 mt-5">
          <Button onClick={() => navigate("/billing")} data-testid="billing-manage-btn">
            {tf("Gérer mon abonnement")} <ArrowUpRight className="h-3.5 w-3.5 ml-1.5" />
          </Button>
          <Button variant="outline" onClick={() => navigate("/billing/plans")} data-testid="billing-plans-btn">
            {tf("Voir les plans")}
          </Button>
        </div>
      </SCard>
    </SectionShell>
  );
};
